export const cssInt = (style, prop) => {
  return parseFloat(style[prop]) || 0
}
